<div class="signal-decision-container">
  <!-- Top Bar with Save & Next Button -->
  <!-- <div class="label-bar">
    <span class="example-spacer"></span>
    <app-common-button
      label="Save & Next"
      title="Save & Next"
      [buttonId]="1111"
      [critical]="false"
      width="110px"
      (clicked)="onNext()"
      style="margin-left: 6px; margin-right: 6px"
    >
    </app-common-button>
  </div> -->

  <!-- Card Container -->
  <div class="card" style="width: 100%; margin-top: 10px;">
    <!-- Action Buttons Row -->
    <div class="action-buttons-row" style="padding: 10px; display: flex; gap: 6px; flex-wrap: wrap;">
      <app-common-button
        title="Refresh"
        icon="fas fa-sync-alt"
        [buttonId]="1111"
        [variant]="'cancel'"
        width="110px"
        (clicked)="onRefresh()"
      >
      </app-common-button>
      
      <app-common-button
        icon="fas fa-download"
        title="Download"
        [buttonId]="1111"
        [variant]="'cancel'"
        [critical]="false"
        width="110px"
        (clicked)="onDownload()"
      >
      </app-common-button>

      <app-common-button
        label="Create"
        title="Create Decision"
        icon="fas fa-plus-circle"
        [buttonId]="1111"
        [variant]="'cancel'"
        [critical]="false"
        width="110px"
        (clicked)="onCreate()"
      >
      </app-common-button>
    </div>

    <!-- Grid Container with fixed height and overflow -->
    <div style="height: 300px; width: 100%; position: relative;">
      <ag-grid-angular
        style="height: 250px; width: 100%;"
        class="ag-theme-balham"
        [rowData]="decisionData"
        [components]="components"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [rowSelection]="'multiple'"
        [suppressRowClickSelection]="true"
        [animateRows]="true"
        [pagination]="true"
        [paginationPageSize]="10"
        (gridReady)="onGridReady($event)"
        [rowHeight]="35"
      [headerHeight]="35"
      [floatingFiltersHeight]="45"
      [enableBrowserTooltips]="true"
        [getRowStyle]="getRowStyle"
      >
      </ag-grid-angular>
    </div>

    <!-- Optional: Custom Pagination Controls (if you want to show page info) -->
    <!-- <div *ngIf="gridApi" class="pagination-info" style="padding: 10px; text-align: right; font-size: 12px; color: #666;">
      Total Records: {{ gridApi?.getModel()?.getRowCount() || 0 }}
    </div> -->
  </div>
</div>